import { Datagrid, DateField, DateInput, List, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";


export function ContestSubmissionShow() {

    return (

        <Show>
            <SimpleShowLayout>
                <ReferenceField source="contestId" reference="contest" >
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="childId" reference="child" >
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="submissionTime"  showTime/>
                <FileInput source="files" title="Uploaded Files" route="contestSubmission/upload" />

            </SimpleShowLayout>
        </Show>
    )
}